import type { ImageWithMetadataFieldsFragment } from 'bundles/front-page/__generated__/contentfulTypes';
import type { BucketCardProps } from 'bundles/front-page/components/modules/buckets/BucketCard';
import { getBucketTestV2Variant } from 'bundles/front-page/utils/showBucketTestV2';

import CareersBucketImage from 'images/front-page/Coursera-Careers-Bucket-v1.png';
import DegreesBucketImage from 'images/front-page/Coursera-Degrees-Bucket-v1.png';
import GenAIBucketImage from 'images/front-page/Coursera-GenAI-Bucket-v1.png';
import AmazonLogo from 'images/front-page/logo-Amazon.png';
import DeepLearningAILogo from 'images/front-page/logo-DeepLearningAI.png';
import MetaLogo from 'images/front-page/logo-Meta.png';
import MicrosoftLogo from 'images/front-page/logo-Microsoft.png';

import _t from 'i18n!nls/front-page';

export const getMockBucketData = (): Omit<BucketCardProps, 'index'>[] => {
  const variant = getBucketTestV2Variant();

  const launchANewCareer = {
    imageUrl: CareersBucketImage,
    title: _t('Launch a new career'),
    body: _t('Get flexible, online training designed to get you job-ready for high-growth fields. '),
    url: '/career-academy',
    linkName: 'career_academy_hub_link',
  };
  const buildInDemandSkills = {
    imageUrl: GenAIBucketImage,
    title: _t('Build in-demand AI skills'),
    body: _t(
      'Learn the fundamentals and grow your generative AI (GenAI) skill set with courses and certificates taught by experts.'
    ),
    url: '/explore/generative-ai',
    linkName: 'ai_skills_hub_link',
  };

  const earnADegree = {
    imageUrl: DegreesBucketImage,
    title: _t('Earn a degree'),
    body: _t('Enroll in a flexible, 100% online degree program to start or advance your career.'),
    url: '/degrees',
    linkName: 'degrees_core_hub_link',
  };

  const mostPopular = {
    imageUrl: GenAIBucketImage,
    title: _t('Most popular courses'),
    body: _t('Build an in-demand skill through these top courses and certificates.'),
    url: '/explore/most-popular-courses',
    linkName: 'most_popular_hub_link',
  };

  if (variant === 'B') {
    return [launchANewCareer, buildInDemandSkills, earnADegree];
  }

  return [launchANewCareer, mostPopular, earnADegree];
};

export const getPartnerLogosData = (partnerLogos: ImageWithMetadataFieldsFragment[]) => {
  return [
    {
      ...partnerLogos.find((logo) => logo.relationSlug === 'google'),
      url: '/search?partners=Google',
    },
    {
      imageAltText: 'DeepLearning.AI',
      image: {
        url: DeepLearningAILogo,
      },
      relationSlug: 'deeplearning-ai',
      url: '/search?partners=DeepLearning.AI',
    },
    {
      ...partnerLogos.find((logo) => logo.relationSlug === 'stanford'),
      url: '/search?partners=Stanford%20University',
    },
    {
      ...partnerLogos.find((logo) => logo.relationSlug === 'ibm-skills-network'),
      url: '/search?partners=IBM',
    },
    {
      ...partnerLogos.find((logo) => logo.relationSlug === 'imperial'),
      url: '/search?partners=Imperial+College+London',
    },
    {
      ...partnerLogos.find((logo) => logo.relationSlug === 'duke'),
      url: '/search?partners=Duke+University',
    },
    {
      ...partnerLogos.find((logo) => logo.relationSlug === 'penn'),
      url: '/search?partners=University+of+Pennsylvania',
    },
    {
      imageAltText: 'Meta',
      image: {
        url: MetaLogo,
      },
      relationSlug: 'meta',
      url: '/search?partners=meta',
    },
    {
      imageAltText: 'Amazon Web Services',
      image: {
        url: AmazonLogo,
      },
      relationSlug: 'aws',
      url: '/search?partners=Amazon%20Web%20Services',
    },
    {
      imageAltText: 'Microsoft',
      image: {
        url: MicrosoftLogo,
      },
      relationSlug: 'microsoft',
      url: '/search?partners=Microsoft',
    },
  ];
};
